import { getCurrentInstance } from 'vue'

export function useLog() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('useLog必须在setup函数中调用')
  }
  return instance.appContext.config.globalProperties.$log
} 